import React from 'react';
import { Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { RegionsType } from 'src/types/SchoolType';
import { useDialogStore } from 'src/stores/DialogStore';

interface Props {
  user_area?: RegionsType;
  isModify?: boolean;
  isTemp? : boolean;
  disable? : boolean;
  setLocations? : any
}

const ManageRegionAdTeam = ({ user_area, isModify, isTemp, disable, setLocations }: Props) => {
  // const setRegions = useDialogStore((state)=>state.setRegions)
  const setTempLocations = useDialogStore((state)=>state.setTempLocations)
  const handleExclude = (province: string, district: string) => {
    if (!user_area) return;
    if (disable) return;
    const updated = { ...user_area };
    updated[province] = updated[province].filter((d) => d !== district);

    if (updated[province].length === 0) {
      delete updated[province];
    }
    if (isTemp){
      setTempLocations(updated)
      return
    }
    setLocations(updated);
    // setRegions(updated)
  };
  
  return (
    <div>
      {Object.entries(user_area ?? {}).flatMap(([province, districts]) =>
        districts.map((district, idx) => (
          <Chip
            key={`${province}-${district}-${idx}`}
            label={`${province} ${district}`}
            {...(!isModify && {
              onDelete: () => handleExclude(province, district),
              deleteIcon: <CloseIcon sx={{width:'16px',height:'16px'}}/>,
            })}
            sx={{ backgroundColor: 'rgba(245,245,245,1)', height:'29px', border:'1px solid #ddd', fontSize:'14px',fontWeight:400, margin:'6px', color: disable ? '#979797': '#000014'}}
          />
        ))
      )}
    </div>
  );
};

export default ManageRegionAdTeam;
